<template>
  <div class="head">
    <router-link to="/Index">
        <img src="../../static/images/logo.png"  class="logoPic"/>
       </router-link>
    <!-- <div class="tablinks-1 tablinks" @click="openTab(0, '/Index')">
      </div> -->
    <div class="tab">
      <div class="tablinks-1 tablinks" @click="openTab(0, '/Index')">
        <div>首页</div>
        <div class="line"></div>
      </div>
      <div class="tablinks-2 tablinks" @click="openTab(1, '/WiseBrain')">
        智能决策引擎
        <div class="line"></div>
      </div>
      <div class="tablinks-3 tablinks">
        <el-popover
          placement="bottom-start"
          width="380"
          popper-class="menu-popover"
          trigger="hover">
          <div class="solutions">
            <div class="solution-item" v-for="(item) in solutionMenus" :key="'solution-item-'+item.index" @click="handleTo(item.index)">
              <img :src="item.url">
              <span>{{ item.name }}</span>
            </div>
          </div>
          <span slot="reference" @click="openTab(2, '/Solution')">行业解决方案 <i class="el-icon-arrow-down"></i></span>
        </el-popover>
      </div>
      <div class="tablinks-4 tablinks" @click="openTab(3, '/News')">
        新闻中心
      </div>
      <div class="tablinks-5 tablinks" @click="openTab(4, '/About')">
        关于北斗院
      </div>
      <div class="tablinks-6 tablinks" @click="openTab(5, '/Join')">
        加入我们
      </div>
    </div>
    <!-- <div class="headRight">
      <div class="headRightInline">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="input21"
        ></el-input>
      </div>
      <div class="headRightInline1">
        <span>CN</span>
        <el-button plain>CN</el-button>
      </div>
    </div> -->
  </div>
</template>


<script>
export default {
  name: "Head",
  data() {
    return {
      input21: "",
      solutionMenus:[
        {
          name:'综合交通行业解决方案',
          url:require('../../static/images/solutionItem1.png'),
          iconHover:'',
          index:1,
        },{
          name:'智慧机场解决方案',
          url:require('../../static/images/solutionItem5.png'),
          iconHover:'',
          index:5,
        },
        {
          name:'智慧高速安全管理平台',
          url:require('../../static/images/solutionItem2.png'),
          iconHover:'',
          index:2,

        },
        {
          name:'智慧物流解决方案',
          url:require('../../static/images/solutionItem6.png'),
          iconHover:'',
          index:6,
        },
        {
          name:'智慧安防解决方案',
          url:require('../../static/images/solutionItem3.png'),
          iconHover:'',
          index:3,
        },
        {
          name:'智慧城市解决方案',
          url:require('../../static/images/solutionItem7.png'),
          iconHover:'',
          index:7,
        },
        {
          name:'智慧轨道解决方案',
          url:require('../../static/images/solutionItem4.png'),
          iconHover:'',
          index:4,
        },
        {
          name:'智慧园区解决方案',
          url:require('../../static/images/solutionItem8.png'),
          iconHover:'',
          index:8,
        }
      ]
    };
  },
   mounted() {
    this.changeStyle(sessionStorage.getItem('saveEvt'))
  },
  methods: {
    handleTo(index){
      this.$router.replace({
        path:'/Solution',
        query:{
          index:index
        }
      })
    },
    changeStyle(index, path){
    let e = document.getElementsByClassName("tablinks");
      for (let i = 0; i < e.length; i++) {
        if (i === parseInt(index)) {
          // 点击的item
          e[i].style['color'] = 'rgba(255, 255, 255, 1)';
        } else {
          // 未被点击的item
          e[i].style['color'] = 'rgba(255, 255, 255, 0.7)';
        }
      }
    },
    openTab(index, path) {
      this.resetSetItem('saveEvt', index);
      this.$router.push({
        path,
      });
    this.changeStyle(index, path)
  },
  }
};
</script>
<style scoped>
@import "./Head.css";
</style>
<style lang="scss">
.el-popover__reference{
  display: flex;
  align-items: center;
  width: 124px;
  i{
    margin-left: 6px;
    font-size: 12px;
  }
}
  .menu-popover{
    background: #070C2A !important;
    border: none !important;
    .popper__arrow{
      display: none !important;
    }
    .solutions{
      width: 100%;
      .solution-item{
        display: flex;
        align-items: center;
        float: left;
        width: 50%;
        height: 30px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        &:hover{
          color: #ffffff;
        }
        img{
          width: 16px;
          margin-right: 10px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Head.vue